import {Transform, Type} from 'class-transformer';

export class Guid {

  public static validator = new RegExp('^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$', 'i');

  public static EMPTY = new Guid().toString();

  private readonly value: string;

  public static isGuid(guid?: any) {
    const value: string = (guid && guid.toString()) || '';
    return guid && (guid instanceof Guid || Guid.validator.test(value));
  }

  public static create(): string {
    return new Guid([Guid.gen(2), Guid.gen(1), Guid.gen(1), Guid.gen(1), Guid.gen(3)].join('-')).toString();
  }

  public static createEmpty(): string {
    return new Guid(Guid.EMPTY).toString();
  }

  public static parse(guid: string): string {
    return new Guid(guid).toString();
  }

  public static equals(from: string | Guid, to: string | Guid): boolean {
    return new Guid(from || Guid.EMPTY).equals(new Guid(to));
  }

  public static raw(): string {
    return [Guid.gen(2), Guid.gen(1), Guid.gen(1), Guid.gen(1), Guid.gen(3)].join('-');
  }

  public static isNullOrEmpty(guid: string) {
    if (guid === null) { return true; }
    if (guid === undefined) { return true; }
    if (guid === Guid.EMPTY) { return true; }
  }

  private static gen(count: number) {
    let out = '';
    for (let i = 0; i < count; i++) {
      // tslint:disable-next-line:no-bitwise
      out += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return out;
  }

  private constructor(guid?: string | Guid) {
    this.value = '00000000-0000-0000-0000-000000000000';

    if (guid && Guid.isGuid(guid)) {
      this.value = guid.toString().toLocaleLowerCase();
    }
  }

  public equals(other?: Guid): boolean {
    // Comparing string `value` against provided `guid` will auto-call
    // toString on `guid` for comparison
    return Guid.isGuid(other) && this.value.toLocaleLowerCase() === other.toString().toLocaleLowerCase();
  }

  public isEmpty(): boolean {
    return this.value === Guid.EMPTY;
  }

  public toString(nullable: boolean = false): string {
    return nullable ? (this.value === Guid.EMPTY ? null : this.value) : this.value;
  }

  public toLowerCase() {
    return this.toString().toLowerCase();
  }

  public toJSON(): any {
    return {
      value: this.value,
    };
  }
}

// export function TypeGuid(nullable = true) {
//   return function (target: any, key: string) {
//     Type(type1 => Guid)(target, key);
//     Transform((value: Guid | Guid[]) => {
//       // console.log("to plain:" + JSON.stringify(value));
//       if (value instanceof Array) {
//         return value.map(value1 => value1.toString(nullable));
//       }
//       return value.toString(nullable);
//     }, {toPlainOnly: true})(target, key);
//     Transform((value: string | string[]) => {
//       // console.log("to class:" + JSON.stringify(value));
//       if (value instanceof Array) {
//         return value.map(value1 => Guid.parse(value1));
//       }
//       return Guid.parse(value);
//     }, {toClassOnly: true})(target, key);
//   };
// }


